<template>
     <div class="control-group no-margin">
        <div class="control toggle-button" :class="{loading : loading}">
            <input
                :id="'snsc_tg_' + id"
                type="checkbox"
                tabindex="-1"
                :checked="active"
            >
            <label :for="id">
                <div class="switch"></div>
            </label>
        </div>
    </div>
</template>

<script setup>
    const props = defineProps({
        id: {
            type: String,
            required: true,
        },

        active: {
            type: Boolean,
            required: true,
        },

        loading : {
            type: Boolean,
            default: false,
        },
    });
</script>

